// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// ** Custom Filters
import { compute as filterSexCompute } from "hooks/filters/useFilterSex";

// ** Utils & Helpers
import { GENDER_TEXT } from "helpers/constants";

// #####################################################
const useSexCoupleFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const {
		sex: sexUrl,
		sex_couple: sexCouple1Url,
		sex_couple_partner: sexCouple2Url,
	} = query || {};

	// ** Filtr - Płeć Para
	const sexCoupleFilterData = useMemo(() => {
		const isCoupleSelected = sexUrl === GENDER_TEXT.COUPLE;
		const sexCouple1Slug = filterSexCompute().valueToUrl(
			Number(sexCouple1Url)
		);
		const sexCouple1Text = sexCouple1Url
			? t(`common:sexOptions.${sexCouple1Slug}`)
			: null;
		const sexCouple2Slug = filterSexCompute().valueToUrl(
			Number(sexCouple2Url)
		);
		const sexCouple2Text = sexCouple2Url
			? t(`common:sexOptions.${sexCouple2Slug}`)
			: null;
		const sexCoupleText = [sexCouple1Text, sexCouple2Text]
			.filter((x) => Boolean(x))
			.join(", ");
		return sexUrl && isCoupleSelected && (sexCouple1Text || sexCouple2Text)
			? {
					label: t("filtersAndSelectors:genderCoupleLabel"),
					selected: sexCoupleText,
			  }
			: null;
	}, [sexUrl, sexCouple1Url, sexCouple2Url, language]);

	// #####################################################

	return sexCoupleFilterData;
};

// #####################################################

export default useSexCoupleFilterData;

// #####################################################
